// extracted by mini-css-extract-plugin
export default {"container":"_1n825rDbJb2MrXA29epUr4","subheader":"_3k0WdPmusnjkUEWXbKJPEW","separator":"_1jLrpqxd3Y6SQcK2MMhgUB"};